import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';
import { FeatureKey } from '../enums';
import { AppSecurityService } from '../services/app-security.service';
import { AttendanceService } from '../services/attendance.service';

/** AB#1119: a reminder grants access to that queue only; ordinary feature guards stay unchanged. */
export const AttendanceGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const security = inject(AppSecurityService);
    const attendance = inject(AttendanceService);
    const denied = () => router.createUrlTree(['/access-denied'], { queryParams: { returnUrl: state.url } });
    return security.ensureFeaturesLoaded().pipe(switchMap(() => {
        if (security.hasFeature(FeatureKey.Attendance) || security.hasFeature(FeatureKey.ClockEditAny)) { return of(true); }
        const teamText = route.queryParamMap.get('teamId');
        if (route.queryParamMap.get('tab') !== 'requests' || teamText === null || !/^\d+$/.test(teamText)) {
            return of(denied());
        }
        const teamId = Number(teamText);
        return attendance.getRequestTeams().pipe(
            map(teams => teams.some(team => team.id === teamId) ? true : denied()),
            catchError(() => of(denied()))
        );
    }));
};
